const clockMarkers = [
    "markerTwelve", 
    "markerOne", 
    "markerTwo", 
    "markerThree", 
    "markerTen", 
    "markerEleven"
]

export default clockMarkers